import React from 'react';
import {inject, observer} from 'mobx-react'
import QuillEditor from 'components/create_workshop/QuillEditor';

@inject('workshopDetails')
@observer
export default class Main extends React.Component {

  // htmlToDrafJs = html => {
  //   const {contentBlocks, entityMap} = htmlToDraft(html);
  //   const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
  //   return EditorState.createWithContent(contentState);
  // };

  render(){
    let model = this.props.workshopDetails.workshop;
    let documents = [];
    if(model.more_info_url)
      documents = [{url: model.more_info_url, file_name: model.more_info_file_name, file_size: model.more_info_file_size}];
    return(
      <div className="col-12 col-md-9">
        <div className="regular-workshop-content">
          <div className="regular-workshop-module purchased">
            <div className="regular-workshop-module-head">
              <h2 className="regular-workshop-module-title">{model.title}</h2>
            </div>

            {!model.description ?
              <div className="loader_block">
                <div className="loader">
                </div>
              </div>
              :
              <QuillEditor
                theme={null}
                value={model.description || ''}
                readOnly={true}
              />
            }

            {documents.length !== 0 &&
            <div className="regular-workshop-module-footer attachments-file" style={{marginBottom: 20}}>
              <p className="regular-workshop-additional">ADDITIONAL INFORMATION:</p>
              <ul className="file-list">
                {documents.map((el, index) =>
                  <a href={el.url} download={true} className="file-link-active" key={index}>
                  <li className="file-item">
                    <div className="file-item-inner" style={{height: '50px'}}>
                      <i className="ic-file-ico file-icon"/>
                      <div className="file-link">
                        {el.file_name}
                        <span className="file-link-size">{parseInt(el.file_size / 1024)} KB</span>
                      </div>
                    </div>
                  </li>
                  </a>)
                }
              </ul>
              {this.props.workshopDetails.workshop.access_type === 'owner' &&
              <div className="workshop-creator-sidebar-publish">
                <Link to={`/createregular/${this.props.workshopDetails.workshop.id}`}><span className="btn prime bordered">Edit</span></Link>
              </div>
              }
            </div>
            }
          </div>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/regular_details/Main.jsx